import redj from "../assets/publications/redj.jpg";
import jmp from "../assets/publications/JMP.jpg";
import estro25 from "../assets/publications/estro2025.jpg";
import mdpid from "../assets/publications/mdpidiagnostics.png";
import mdpiap from "../assets/publications/mdpiappliedscience.png";
import ai_chapter from "../assets/publications/AI_Summit-Chapter.pdf";
import indiaai from "../assets/publications/INDIAAI.png";

// add items in the list
export const publications =[
    {
        num:1,
        title:"Framework for Machine Learning of CT and PET Radiomics to Predict Local Failure after Radiotherapy in Locally Advanced Head and Neck Cancers",
        authors:"Devakumar, D., Sunny, G., Sasidharan, B. K., Bowen, S. R., Nadaraj, A., Jeyseelan, L., Mathew, M., Irodi, A., Isiah, R., Pavamani, S., John, S., & T Thomas, H. M.",
        journal:"Journal of Medical Physics",
        link:"https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8491314/",
        thumbnail: jmp,
        year:"2021"
    },
    {
        num:2,
        title: "Prognostic Value of Early Fluorodeoxyglucose-Positron Emission Tomography Response Imaging and Peripheral Immunologic Biomarkers: Substudy of a Phase II Trial of Risk-Adaptive Chemoradiation for Unresectable Non-Small Cell Lung Cancer",
        authors: "Stephen R. Bowen, Daniel S. Hippe, Hannah M. Thomas, Balukrishna Sasidharan, Paul D. Lampe, Christina S. Baik, Keith D. Eaton, Sylvia Lee, Renato G. Martins, Rafael Santana-Davila, Delphine L. Chen, Paul E. Kinahan, Robert S. Miyaoka, Hubert J. Vesselle, A. McGarry Houghton, Ramesh Rengan, Jing Zeng",
        journal: "Advances in Radiation Oncology",
        link:"https://doi.org/10.1016/j.adro.2021.100857",
        thumbnail:"https://cdn.clinicalkey.com/ck-thumbnails/24521094/S2452109421X00097/cov200h.gif",
        year: "2022"
    },
    {
        num:3,
        title:"Can CBCT-Based Delta Radiomics Predict Normal Lung Toxicity during Thoracic Radiation?",
        authors:"N. Jose, A.J. Varghese, H.M. Thomas, A. Irodi, J.C. Paul, M. Mathew, R. Isiah, S. John, H.F. Godson, T.B. Peace, S.P. Pavamani, D. Devadhas, B.K. Sasidharan",
        journal:"International Journal of Radiation Oncology - Biology - Physics (IJROBP)",
        link:"https://doi.org/10.1016/j.ijrobp.2022.07.934",
        thumbnail:"https://ars.els-cdn.com/content/image/X03603016.jpg",
        year:"2022"
    },
    {
        num:4,
        title:"Utility of Mid-treatment DWI in Selecting Pathological Responders to Neoadjuvant Chemoradiotherapy in Locally Advanced Esophageal Cancer",
        authors:"Neenu Oliver John, Aparna Irodi, Hannah Mary T. Thomas, Vijay Abraham, Balu Krishna Sasidharan, Subhashini John & Simon P. Pavamani",
        journal:"Journal of Gastrointestinal Cancer",
        link:"https://link.springer.com/article/10.1007/s12029-022-00818-y",
        thumbnail:"https://media.springernature.com/w138/springer-static/cover/journal/12029.jpg",
        year:"2022"
    },
    {
        num:5,
        title:"Radiation and immune checkpoint inhibitor-mediated pneumonitis risk stratification in patients with locally advanced non-small cell lung cancer: role of functional lung radiomics?",
        authors:"Hannah M. T. Thomas, Daniel S. Hippe, Parisa Forouzannezhad, Balu Krishna Sasidharan, Paul E. Kinahan, Robert S. Miyaoka, Hubert J. Vesselle, Ramesh Rengan, Jing Zeng & Stephen R. Bowen",
        journal:"Discover Oncology",
        link:"https://link.springer.com/article/10.1007/s12672-022-00548-4",
        thumbnail:"https://media.springernature.com/w138/springer-static/cover/journal/12672.jpg",
        year:"2022"
    },
    {
        num:6,
        title:"Quantum of Corneal Scarring Calculation by Image Analysis of Anterior Segment OCT Images",
        authors:"Cassandra D Solomons, Ammu Anna Mathew, Karthikeyan V, Vivekanandan Shanmugasundaram, Hannah Mary Thomas, A Sathya, Jeyanth Rose",
        journal:"IEEE",
        link:"https://ieeexplore.ieee.org/document/9945025",
        // thumbnail:"https://ieeexplore.ieee.org/assets/img/ieee_logo_white.svg",
        // thumbnail:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjIJa3jgYfLleQDKJ9Guhao4zvimwiw_--Rw&s",
        thumbnail:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSki7YKgdaMbPqcJyCz3vAil7f0aaR0phVqOg&s",
        year:"2022"
    },
    {
        num:7,
        title:"Multi-centre Radiomics for prediction of recurrence following Radical Radiotherapy for Head and Neck Cancers: Consequences of feature selection, machine learning classifiers and batch-effect harmonization",
        authors:"Amal Joseph Varghese, Varsha Gouthamchand, S. Balu Krishna, Leonard Wee, Sharief K. Sidhique, Julia Priyadarshini Rao, Andre Dekker, Frank Hoebers, D. Devakumar, Aparna Irodi, Timothy Peace Balasingh, Henry Finlay Godson, T. Joel, Manu Mathew, Rajesh Isiah, Simon Pavamani, T. Hannah Mary Thomas",
        journal:"Physics and Imaging in Radiation Oncology",
        link:"https://doi.org/10.1016/j.phro.2023.100450",
        thumbnail:"https://ars.els-cdn.com/content/image/X24056316.jpg",
        year:"2023"
    },
    {
        num:9,
        title:"Reproducibility in Radiomics: A Comparison of Feature Extraction Methods and Two Independent Datasets",
        authors:"Hannah Mary T. Thomas, Helen Y. C. Wang, Amal Joseph Varghese, Ellen M. Donovan, Chris P. South, Helen Saxby, Andrew Nisbet, Vineet Prakash, Balu Krishna Sasidharan, Simon Pradeep Pavamani, Devakumar D., Manu Mathew, Rajesh Gunasingam Isiah and Philip M. Evans",
        journal:"MDPI Applied Sciences",
        link:"https://www.mdpi.com/2076-3417/13/12/7291",
        thumbnail:mdpiap,
        year:"2023"
    },
    // {
    //     num:10,
    //     title:"Can pre-treatment MRI and CT radiomics improve prediction of complete pathological response in locally advanced rectal cancer following neoadjuvant treatment?",
    //     authors:"Jeba Karunya Reddy, A Sathya, Amal Joseph Varghese, Arvind Sathyamurthy, Neenu Oliver John, Anuradha Chandramohan, Ashish Singh, Anjana Joel, Rohin Mittal, Dipti Masih, Kripa Varghese, Thomas Samuel Ram, Hannah Mary T Thomas",
    //     journal:"This is a preprint",
    //     link:"https://doi.org/10.21203/rs.3.rs-3756695/v1",
    //     thumbnail:"",
    //     year:"2024"
    // },
    {
        num:10,
        title:"Teleradiology and technology innovations in radiology: status in India and its role in increasing access to primary health care",
        authors:"Anuradha Chandramohan, Viswajit Krothapalli, Ann Augustin, Madhavi Kandagaddala, Hannah Mary Thomas, Thambu David Sudarsanam, Ammar Jagirdar, Shalini Govil, Arjun Kalyanpur",
        journal:"The Lancet Regional Health - Southeast Asia",
        link:"https://doi.org/10.1016/j.lansea.2023.100195",
        thumbnail:"https://www.thelancet.com/cms/asset/42dacfd4-28e0-40cd-8f1d-faf2970b2884/cov200h.gif",
        year:"2023"
    },
    {
        num:11,
        title:"Is radiomics a useful addition to magnetic resonance imaging in the preoperative classification of PitNETs?",
        authors:"Sathya A, Abhijit Goyal-Honavar, Ari G Chacko, Anitha Jasper, Geeta Chacko, Devadhas Devakumar, Joshua Anand Seelam, Balu Krishna Sasidharan, Simon P Pavamani & Hannah Mary T Thomas",
        journal:"Acta Neurochirurgica",
        link:"https://doi.org/10.1007/s00701-024-05977-4",
        thumbnail:"https://media.springernature.com/w120/springer-static/cover/journal/701.jpg?as=webp",
        year:"2024"
    },
    {
        num:12,
        title:"Can Pretreatment MRI and Planning CT Radiomics Improve Prediction of Complete Pathological Response in Locally Advanced Rectal Cancer Following Neoadjuvant Treatment?",
        authors:"Jeba Karunya Ramireddy, A. Sathya, Balu Krishna Sasidharan, Amal Joseph Varghese, Arvind Sathyamurthy, Neenu Oliver John, Anuradha Chandramohan, Ashish Singh, Anjana Joel, Rohin Mittal, Dipti Masih, Kripa Varghese, Grace Rebekah, Thomas Samuel Ram & Hannah Mary T. Thomas",
        journal:"Journal of Gastrointestinal Cancer",
        link:"https://doi.org/10.1007/s12029-024-01073-z",
        thumbnail:"https://media.springernature.com/w120/springer-static/cover-hires/journal/12029?as=webp",
        year:"2024"
    },
    {
        num:13,
        title:"Pragmatic Patient Choice-Driven Radical Treatment Approach (PRAGRAD) for Very Advanced Unresectable Oral Cavity Cancers",
        authors:`Balu Krishna Sasidharan, Sharief K. SidhiquE, Jino Victor Wilson, Manu Mathew, Amit Jiwan Tirkey,
                    Ashish Singh, Jenifer Jeba Sundararaj,Hannah Mary T Thomas, Swathi, Benny Rajendra Kuchipudi,
                    Jerome Sunny, Anjana Joel, Annie Jacob, Vidya Konduru,
                    Mansi Agarwal, Aparna Irodi, Jeyashanth Riju,Natarajan Ramalingam, Rajiv Michael,Rajesh Isiah,
                    Anjana Chandran, Sharon Gikku George, Praveenraj, Andre Dekker,
                    Leonard Wee,Frank Hoebers,and Simon P Pavamani`,
        journal:"International Journal of Radiation Oncology*Biology*Physics",
        link:"https://www.redjournal.org/article/S0360-3016(25)03906-9/fulltext",
        thumbnail:redj,
        year:"2025"
    },
    {
        num:14,
        title:"Gross Tumour Volume segmentation by federated deep learning using real-world data of 3500+ lung cancer patients from 20 institutions in10 countries",
        authors:"Leroy Volmer, Ananya Choudhury, Johan van Soest, Andre Dekker, Diogo FDC Patrao, Bram Steiltjes, Emiliano Spezi, Rajesh Jena, Gareth Price, Hannah M Thomas, Zhen Zhang, Robin Wijsman, Andrea Damiani, Rogier Janssen, Brent Van der Heyden, John Lilley, Thomas J Dilling, Abdul Nazeer, Tomas Janssen, Per Ivar Lønne, René Monshouwer, Ying Xiao, Stephanie Tanadini-Lang, Leonard Wee",
        journal:"European Society for Radiotherapy and Oncology",
        link:"https://user-swndwmf.cld.bz/ESTRO-2025-Abstract-Book/2554/",
        thumbnail:estro25,
        year:"2025"
    },
    {
        num:15,
        title:"Blueprint for getting AI-ready data from a clinical setting",
        authors:"Hannah Mary Thomas T, Balu Krishna S, Rajendra Benny Kuchipidi, Joy Mammen, Arun Zechariah, Thomas Samuel Ram, Simon Pradeep Pavamani",
        journal:"India AI Summit",
        link:ai_chapter,
        thumbnail:indiaai,
        year:"2026"
    },
    {
        num:16,
        title:"Decoding Uncertainty Quantification for Oncology—An Illustration Using Radiomics",
        authors:"Florian van Daalen, Balu Krishna Sasidharan, C Praveenraj, Amal Joseph Varghese, Andre Dekker, Leonard Wee, Rianne Fijten, Aparna Irodi, Hannah Mary T Thomas",
        journal:"MDPI Diagnostics",
        link:"https://www.mdpi.com/2075-4418/16/5/700",
        thumbnail:mdpid,
        year:"2026"
    },
    // {
    //     num:13,
    //     title:"",
    //     authors:"",
    //     journal:"",
    //     link:"",
    //     thumbnail:"",
    //     year:""
    // },
]